import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-batch",
  "use": "icon-batch-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-batch\">\r\n<path d=\"M47.9,51.3c-3.4,0-6.1,2.6-6.4,5.9l0,0.5v12.8H28.7c-3.4,0-6.1,2.6-6.4,5.9l0,0.5c0,3.4,2.6,6.1,5.9,6.4l0.5,0h12.8v12.8\r\n\tc0,3.4,2.6,6.1,5.9,6.4l0.5,0c3.4,0,6.1-2.6,6.4-5.9l0-0.5V83.3h12.8c3.4,0,6.1-2.6,6.4-5.9l0-0.5c0-3.4-2.6-6.1-5.9-6.4l-0.5,0\r\n\tH54.3V57.7c0-3.4-2.6-6.1-5.9-6.4L47.9,51.3z M96,83.3h12.8c3.4,0,6.1-2.6,6.4-5.9l0-0.5V19.2c0-3.5-2.9-6.4-6.4-6.4l0,0H51.1\r\n\tc-3.4,0-6.1,2.6-6.4,5.9l0,0.5V32h38.4C90.2,32,96,37.8,96,44.9L96,83.3L96,83.3z M96,115.3c0,7.1-5.7,12.8-12.8,12.8H12.7\r\n\tc-7.1,0-12.8-5.7-12.8-12.8V44.9c0-7.1,5.7-12.8,12.8-12.8l0,0h19.2V12.8C31.9,5.7,37.6,0,44.7,0l0,0h70.5c7.1,0,12.8,5.7,12.8,12.8\r\n\tv70.5c0,7.1-5.7,12.8-12.8,12.8H96V115.3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/batch.svg
// module id = ccNl
// module chunks = 87